<div>
  <mat-dialog-content>
    <h3>Doładowania telefonu są tymczasowo niedostępne.</h3>
    <p>Przepraszamy za niedogodności.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="start">
    <button mat-raised-button mat-dialog-close>Wróć</button>
    <button mat-raised-button color="primary" (click)="removeFromCart()">
      {{ data?.cancel ? 'Anuluj płatność' : 'Usuń z koszyka' }}
    </button>
  </mat-dialog-actions>
</div>
